const px = (style, name) => parseFloat(style[name]) || 0

export function fitTextareaHeight(el, maxLines) {
  const style = getComputedStyle(el)
  const borders = px(style, 'borderTopWidth') + px(style, 'borderBottomWidth')
  const maxHeight = px(style, 'lineHeight') * maxLines + px(style, 'paddingTop') + px(style, 'paddingBottom') + borders
  el.style.height = 'auto'
  const contentHeight = el.scrollHeight + borders
  el.style.height = `${Math.min(contentHeight, maxHeight)}px`
  el.style.overflowY = contentHeight > maxHeight ? 'auto' : 'hidden'
}

export function clearTextareaHeight(el) {
  el.style.height = ''
  el.style.overflowY = ''
}
